import styled from 'styled-components';

export const SubTitle = styled.div`
  padding-top: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
